import { useCallback, useEffect, useState } from 'react';

import { EMAIL_TEMPLATE_TYPES } from 'constants/email-config';
import { useTranslation } from 'react-i18next';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { EmailTemplateStep } from 'components/EmailTemplateStep/EmailTemplateStep';
import { Button, InputGroup, Textarea } from 'components/FormComponents';

export const ReplaceRefereeModal = ({
  brand = {},
  referee,
  visible,
  onClose = () => {},
  onCancel = () => {},
  onReplacementRequest = () => {},
}) => {
  const { t } = useTranslation();
  const [message, setMessage] = useState('');
  const [emailTemplateStepKey, setEmailTemplateStepKey] = useState(0);

  const resetModalState = useCallback(() => {
    setMessage('');
  }, []);

  useEffect(() => {
    resetModalState();
    if (visible) {
      setEmailTemplateStepKey(k => k + 1);
    }
  }, [visible, resetModalState]);

  return (
    <AnimatedModal
      visible={visible}
      onClose={onClose}
      title={t('check.refereeReplacement.title')}
      noPadding>
      <div className="p-6 max-h-[85vh] overflow-y-auto">
        <p className="text-xl text-neutral-6 mb-4">
          {t('check.refereeReplacement.intro', { name: referee?.name ?? '' })}
        </p>
        <InputGroup title="Optional message for candidate">
          <Textarea
            inputProps={{ value: message, onChange: e => setMessage(e.target.value), rows: 5 }}
          />
        </InputGroup>
        <EmailTemplateStep
          key={emailTemplateStepKey}
          brand={brand}
          category="candidate"
          type={EMAIL_TEMPLATE_TYPES.REPLACE_REFEREE}
          standardName={t('check.refereeReplacement.emailStandardName')}
          standardDescription={t('check.refereeReplacement.emailStandardDescription')}
          previewStandardMessage={t('check.refereeReplacement.emailPreviewStandard')}
          submitLabel={t('check.refereeReplacement.sendRequest')}
          footerLeft={
            <Button type="secondary" onClick={onCancel}>
              {t('check.refereeReplacement.cancelReferee')}
            </Button>
          }
          onSubmit={templateId => onReplacementRequest(templateId, message)}
        />
      </div>
    </AnimatedModal>
  );
};
